import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
/* eslint-disable import/no-cycle */
import React from "react";
import "./banner.scss";
import { useSelector } from "react-redux";
export const getGreeting = () => {
    const time = new Date().getHours();
    const greeting = "Good ";
    if (time < 12) {
        return `${greeting} Morning!`;
    }
    if (time < 18) {
        return `${greeting} Afternoon!`;
    }
    return `${greeting} Evening!`;
};
const Banner = () => {
    const user = useSelector((state) => state.user);
    return (_jsx(_Fragment, { children: _jsx("div", { className: "my-profile__banner", children: _jsxs("div", { className: "my-profile__banner-right", children: [_jsx("span", { className: "my-profile__banner-right-greeting", children: getGreeting() }), _jsx("div", { className: "my-profile__banner-right-user-name-wrapper", children: _jsx("span", { className: "my-profile__banner-right-user-name", children: user.name }) }), _jsx("span", { className: "my-profile__banner__dynamic_copy", children: user.user_class === "byb" ? "" : user.summary_text }), _jsxs("span", { className: "my-profile__banner__hashtag", children: ["#TeamGainful since\u00A0", user.gainful_member_since] })] }) }) }));
};
export default Banner;
